import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

import { LunaCarousel } from '../carousel/carousel.component';
import { LoginService } from '../../../services/login.service';
import { SessionService } from '../../../services/session.service';
import { UserService } from '../../../services/user.service';
import { LoginRequest } from '../../objects/loginRequest';
import { environment } from '../../../environments/environment';
import { TroubleshootComponent } from '../troubleshoot/troubleshoot.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';

@Component({
	standalone: true,
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrl: './home.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [ReactiveFormsModule, LunaCarousel, RouterLink]
})
export class HomeComponent implements OnInit {

	public loginForm: FormGroup;
	loading = false;
	errorMessage = '';
	successMessage = '';
	submitted = false;

	constructor(
		private router: Router,
		private formBuilder: FormBuilder,
		private loginService: LoginService,
		private modalService: NgbModal,
		private sessionService: SessionService,
		private userService: UserService
	) {
		this.loginForm = this.formBuilder.group({
			username: ['', [Validators.required, Validators.email]],
			password: ['', [Validators.required, Validators.minLength(6)]]
		})
	}

	ngOnInit() {
		document.body.classList.add('home-body-style');
	}

	onSubmit() {
		this.submitted = true;
		this.errorMessage = '';
		this.successMessage = '';

		if (this.loginForm.invalid) {
			return;
		}

		this.loading = true;
		const loginRequest: LoginRequest = {
			email: this.loginForm.value.username,
			password: this.loginForm.value.password,
			twoFactorCode: null,
			twoFactorRecoveryCode: null
		};

		this.loginService.login(loginRequest)
			.subscribe({
				next: async (response) => {
					this.loading = false;

					this.sessionService.storeTokens(response);

					const userClaims = await firstValueFrom(this.loginService.getInfo(response.accessToken));
					if (userClaims) {
						this.userService.setUserInfo(userClaims);
						this.sessionService.storeUserInfo(userClaims);
					}

					window.location.href = `${environment.popUrl}Auth/HandleJwt?token=${response.accessToken}`;
				},
				error: (error) => {
					this.loading = false;
					if (error.status == 401) {
						this.errorMessage = error.error.detail;
					} else {
						this.errorMessage = 'Something went wrong. Please try again later.'
					}
				}
			});
	}

	openTroubleshoot() {
		this.modalService.open(TroubleshootComponent, {
			keyboard: true,
			size: 'lg',
			backdropClass: 'light-blue-backdrop',
			centered: true
		});
	}

	loginWithSSO() {
		this.router.navigate(['/redirect']);
	}

	ngOnDestroy() {
		document.body.classList.remove('home-body-style');
	}
}
